import { ComponentType } from 'react';

export interface InlineBoardLinkOptions {
    clickableLinksWhenEditable: boolean;
    dispatchFetchInlineBoardLinkDetails: DispatchFetchInlineBoardLinkDetails;
    urlOrigin: string;
    addSpaceOnCreation: boolean;
    BoardIconComponent?: ComponentType;
}

export enum InlineBoardLinkStatus {
    initial = 'initial',
    resolved = 'resolved',
}

export type InlineBoardLinkDetails = {
    url: string;
    boardId: string;
    permissionId: string;
    title: string;
    color: string;
};

export type InlineBoardLinkAttributes = InlineBoardLinkDetails & {
    status: string;
};

export type FetchInlineBoardLinkDetailsResponse = Promise<Partial<InlineBoardLinkDetails> | null>;
export type DispatchFetchInlineBoardLinkDetails = (
    elementId: string,
    permissionId?: string,
) => FetchInlineBoardLinkDetailsResponse;
